/**
 * The bound on the number of non-empty lines a pasted site-parameters list may carry — SITE-24
 * (Update Site Parameters) extension 2a; shared so the form and the use case refuse at the same line.
 */
export const siteParameterListMaxNonEmptyLines = 10000;
